<template>
  <div
    v-if="message"
    class="alert-message"
    :class="`alert-message--${variant}`"
  >
    <span v-if="prefix">{{ prefix }}</span>
    <span class="u-rich-text" v-safe-html="message"></span>
  </div>
</template>

<script>
// Generic inline alert box. `message` may contain trusted-looking HTML from
// the API/BE (e.g. duplicate-date lists), so it is rendered via the
// v-safe-html directive rather than v-html.
export default {
  props: {
    message: {
      type: String,
      default: ""
    },
    prefix: {
      type: String,
      default: ""
    },
    variant: {
      type: String,
      default: "danger",
      validator: (value) =>
        ["danger", "warning", "info", "success"].includes(value)
    }
  }
};
</script>
